import HomeComponent from "@/components/default/HomeComponent.vue";
import { request } from "@/js/http/http_request";
import { tenantType } from "@/js/lists.ts";
export default {
  name: "Home",
  components: {
    HomeComponent: HomeComponent
  },
  data: function data() {
    return {
      isLoading: true
    };
  },
  beforeRouteEnter: function beforeRouteEnter(_to, _from, next) {
    next(function (vm) {
      var clientAppData = {
        client_id: vm.$whitelabel.clientId,
        client_secret: vm.$whitelabel.clientSecret
      };
      request("/v1/tenants/informations", "post", clientAppData, false, "cap").then(function (res) {
        var tenant_type = res.data.tenant_type;
        if (tenant_type === tenantType.TENANT) next({
          name: "login"
        });else {
          vm.isLoading = false;
          next();
        }
      });
    });
  }
};